export default {
	namespaced: true,
	state: {
		abortController: new AbortController(),
		abortControllers: [],
	},
	getters: {
		ABORT_CONTROLLERS: state => state.abortControllers,
	},
	mutations: {
		SET_ABORT_CONTROLLER: (state, data) => {
			state.abortControllers.push(data)
		},
		RUN_ABORT_CONTROLLER: (state, methodName) => {
			switch (methodName) {
				case 'abort': {
					for (const key in state.abortControllers) {
						const abortElement = state.abortControllers[key].data
						abortElement.abort()
					}

					state.abortControllers = []
					break
				}
			}
		},
	},
	actions: {
		setAbortController({ commit }, data) {
			commit('SET_ABORT_CONTROLLER', data)
		},
		runAbortControllerByParam({ commit }, methodName) {
			commit('RUN_ABORT_CONTROLLER', methodName)
		},
	}
}